module.exports = __webpack_public_path__ + "static/food-background-10eb937a8c88d2330eef90111ee3a082.jpg";